import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { useTranslations } from '~/i18n/use-translations.ts';
import { getWatchlistPageDataQueryOptions } from '~/server/watchlist/watchlist-page-data-query.ts';

export const Route = createFileRoute('/watchlists/$watchlistIndex/news')({
	component: WatchlistNewsPage,
});

function WatchlistNewsPage() {
	const t = useTranslations();
	const { watchlistIndex } = Route.useParams();
	const { data: loaderData } = useSuspenseQuery(
		getWatchlistPageDataQueryOptions({ watchlistIndex: Number(watchlistIndex) }),
	);
	const watchlist = loaderData.watchlists[loaderData.watchlistIndex];

	return (
		<div>
			<div className="flex justify-center border-border border-b-2">{t('watchlist.news')}</div>
			{watchlist ? <Outlet /> : null}
		</div>
	);
}
